module.exports = __webpack_public_path__ + "img/mic.c938f952.svg";